export default "__VITE_ASSET__voqJvmUJ__"